import React from 'react';
import ArrowHead from './ArrowHead';
import { LinkArrowVariant } from '../types';
var ARROW_SIZE = 8;
var ArrowHeads = function () {
    return (React.createElement("defs", null,
        React.createElement(ArrowHead, { name: LinkArrowVariant.NONE, path: '' }),
        React.createElement(ArrowHead, { name: LinkArrowVariant.ARROW_HEAD, path: 'M-' + ARROW_SIZE + ',-' + (ARROW_SIZE * 0.5)
                + ' L0,0 L-' + ARROW_SIZE + ',' + (ARROW_SIZE * 0.5)
                + ' L0,0 L-' + ARROW_SIZE + ',-' + (ARROW_SIZE * 0.5) + ' Z' }),
        React.createElement(ArrowHead, { name: LinkArrowVariant.CLOSED_ARROW_HEAD, path: 'M-' + ARROW_SIZE + ',-' + (ARROW_SIZE * 0.5)
                + ' L0,0 L-' + ARROW_SIZE + ',' + (ARROW_SIZE * 0.5)
                + ' L-' + ARROW_SIZE + ',-' + (ARROW_SIZE * 0.5) + ' Z' })));
};
export default ArrowHeads;
//# sourceMappingURL=ArrowHeads.js.map